// in src/Dashboard.js
import React, { Component, Fragment } from 'react';
import { GET_LIST, Responsive, Title, WithPermissions } from 'react-admin';
import DisconnectedResources from './DisconnectedResources';
import ErrorResources from './ErrorResources';
import dataProvider from '../../dataProvider';

const styles = {
    flex: { display: 'flex' },
    flexColumn: { display: 'flex', flexDirection: 'column' },
    leftCol: { flex: 1, marginRight: '1em' },
};

class MyDashBoard extends Component {
    state = {};
    componentDidMount()
    {
        dataProvider(GET_LIST, 'terminals', {
            filter: { status: 2},
            sort: { field: 'lastAccessDateTime', order: 'ASC' },
            pagination: { page: 1, perPage: 25 },
        })
            .then(response => {
                this.setState({ disconnectedTerminals: response.data });
                this.setState({ totalDisconnectedTerminals: response.total });
            })
        
        dataProvider(GET_LIST, 'resources', {
            filter: { calendarAccessibility: 2, isMonitored: true},
            sort: { field: 'name', order: 'ASC' },
            pagination: { page: 1, perPage: 25 },
        })
            .then(response => {
                this.setState({ errorResources: response.data });
                this.setState({ totalErrorResources: response.total });
            })
    }

    render() {
        const {
            disconnectedTerminals,
            totalDisconnectedTerminals,
            errorResources,
            totalErrorResources,
        } = this.state;

        const { permissions } = this.props
        return (
            <Fragment>
                <Title title='dashboard.title'/>
                <Responsive
                    xsmall={
                        <div>
                            <div style={styles.flexColumn}>
                                <div style={styles.flex}>
                                    {(permissions & 1) !== 0 ? <DisconnectedResources terminals={disconnectedTerminals} total={totalDisconnectedTerminals}/> : null}
                                    {(permissions & 1) !== 0 ? <ErrorResources resources={errorResources} total={totalErrorResources}/> : null}
                                </div>
                            </div>
                        </div>
                    }
                    small={
                        <div style={styles.flexColumn}>
                            <div style={styles.flex}>
                                {(permissions & 1) !== 0 ? <DisconnectedResources terminals={disconnectedTerminals} total={totalDisconnectedTerminals}/> : null}
                                {(permissions & 1) !== 0 ? <ErrorResources resources={errorResources} total={totalErrorResources}/> : null}
                            </div>
                        </div>
                    }
                    medium={
                        <div style={styles.flex}>
                            <div style={styles.leftCol}>
                                <div style={styles.flex}>
                                    {(permissions & 1) !== 0 ? <DisconnectedResources terminals={disconnectedTerminals} total={totalDisconnectedTerminals}/> : null}
                                    {(permissions & 1) !== 0 ? <ErrorResources resources={errorResources} total={totalErrorResources}/> : null}
                                </div>
                            </div>
                        </div>
                    }
                />
            </Fragment>
        );
    }
}

const MyDashBoardWithPermissions = ({ location, permissions }) => (
    <WithPermissions
        location={location}
        render={({ permissions }) => <MyDashBoard permissions={permissions} />}
    />

)

export default MyDashBoardWithPermissions;